type Platform = 'ipad' | 'iphone' | 'android' | 'mac' | 'windows' | '';

const getPlatform = (): Platform => {
    const userAgent = window.navigator.userAgent;

    const rules = [
        [/\(iPad;/, 'ipad'],
        [/\(iPhone;/, 'iphone'],
        [/ Android /, 'android'],
        [/ Mac OS X /, 'mac'],
        [/ Windows /, 'windows'],
    ];
    for (let i = 0; i < rules.length; i++) {
        const tmp = rules[i];
        const rule = tmp[0] as RegExp;
        const name = tmp[1] as Platform;
        const rRes = rule.exec(userAgent);
        if (rRes) {
            return name;
        }
    }
    return '';
};

export const _isIOS = (): boolean =>
    ['ipad', 'iphone'].indexOf(getPlatform()) > -1;

export const isIOS: boolean = _isIOS();
